import * as angular from 'angular';
import {IController} from "angular";

export class BillingAccountDisplayValueCtrl implements IController {
  id: any;

  private billingAccountsRef: any;
  private selectedBillingAccount: any;

  constructor(private $billingAccounts, private $log) {
    this.billingAccountsRef = this.$billingAccounts();
  }

  $onInit() {
    this.setItem(this.id);
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.setItem(this.id);
    }
  }

  private setItem(id) {
      if (id) {
        this.billingAccountsRef.$asyncValues([id])
          .then((billingAccounts) => {
            this.selectedBillingAccount = billingAccounts[0];
          })
          .catch((error) => {
            this.$log.error('Failed to get branches', error);
          })
      } else {
        this.selectedBillingAccount = undefined;
      }
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountDisplayValue', {
    bindings: {
      id: '<',
      onChange: '&'
    },
    template: require('./billing-account-display-value.html').default,
    controller: BillingAccountDisplayValueCtrl
  });
